/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppleLoginDto } from '../../models/apple-login-dto';
import { OAuthResponseDto } from '../../models/o-auth-response-dto';

export interface AppleAuthControllerAppleLogin$Params {
      body: AppleLoginDto
}

export function appleAuthControllerAppleLogin(http: HttpClient, rootUrl: string, params: AppleAuthControllerAppleLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, appleAuthControllerAppleLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OAuthResponseDto>;
    })
  );
}

appleAuthControllerAppleLogin.PATH = '/api/oauth/apple/signin';
